import { RouterModule, Routes } from '@angular/router'
import { NgModule } from '@angular/core'

import { StaffComponent } from './staff/staff.component'
import { ClinicComponent } from './clinic/clinic.component'
import { AuthGuard } from '../../../services/guarad/auth.guard'
import { CommonComponent } from './common/common.component'
import { LayoutAppElementComponent } from '../layout_app_element/layout-app-element.component'
import { BehaviourComponent } from './behaviour/behaviour.component'
import { MailComponent } from './mail/mail.component'
import { DeviceComponent } from './device/device.component'
import { PendingChangesGuard } from '../../../services/guarad/pending-changes.guard'
import { PaymentComponent } from './payment/payment.component'
import { DocumentComponent } from './document/document.component'

const routes: Routes = [
    {
        path: 'app/main/setting',
        canActivate: [AuthGuard],
        component: LayoutAppElementComponent,
        canDeactivate: [PendingChangesGuard],
        children: [
            { path: '', redirectTo: 'staff', pathMatch: 'full', canDeactivate: [PendingChangesGuard] },
            { path: 'staff', component: StaffComponent, canDeactivate: [PendingChangesGuard] },
            { path: 'clinic', component: ClinicComponent, canDeactivate: [PendingChangesGuard] },
            { path: 'common', component: CommonComponent, canDeactivate: [PendingChangesGuard] },
            { path: 'option', component: BehaviourComponent, canDeactivate: [PendingChangesGuard] },
            { path: 'mail', component: MailComponent, canDeactivate: [PendingChangesGuard] },
            { path: 'device', component: DeviceComponent, canDeactivate: [PendingChangesGuard] },
            { path: 'payment', component: PaymentComponent, canDeactivate: [PendingChangesGuard] },
            { path: 'payment-registered-card', component: PaymentComponent, canDeactivate: [PendingChangesGuard] },
            { path: 'document', component: DocumentComponent },
            // {path: '**', component: PromotionComponent},
        ],
    },
]

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})

export class SettingRoutingModule {
    constructor(public pendingChangesGuard: PendingChangesGuard) {
    }

}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/setting/setting.routing.ts